import { RetrieveRulesPayload, RuleStatus } from 'app/modules/rules/models';
import { RuleSearchPayload } from 'app/modules/search/payload';
import { ValidationAlertsPayload } from 'app/modules/detectionModels/models';

const BASE = ['rules'] as const;

export const RULE_QUERY_KEYS = {
  getRule: (ruleId: number, ruleStatus: RuleStatus) =>
    [...BASE, 'rule', ruleId, ruleStatus] as const,
  getRules: (payload: RetrieveRulesPayload) =>
    [...BASE, 'get-rules', payload] as const,
  getRuleSearch: (payload?: RuleSearchPayload) =>
    payload ? ([...BASE, 'search', payload] as const) : [...BASE, 'search'],
  getRuleValidationAlerts: (payload: ValidationAlertsPayload) =>
    [...BASE, 'validation-alerts', payload] as const,
};
